import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const AccumulatorsRoutes: Routes = [
  {
    path: "accumulators",
    loadComponent: () =>
      import("./accumulators/accumulators.component").then(
        (m) => m.AccumulatorsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./accumulator-list/accumulator-list.component").then(
            (m) => m.AccumulatorListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./accumulator-form/accumulator-form.component").then(
            (m) => m.AccumulatorFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./accumulator-form/accumulator-form.component").then(
            (m) => m.AccumulatorFormComponent,
          ),
      },
    ],
  },
];
